<template>
  <div class="input-copy-content"
    :class="{
      'input-copy-content_box': boxMode
    }">
    <div ref="valueContainer" class="input-copy-content__value truncate"
    :class="{
      'input-copy-content__value_box': boxMode
    }">
      {{value}}
    </div>
    <div
      class="input-copy-content__copy-btn"
      @click="copyToClipboard"
    >
      <i
        aria-hidden="true"
        class="far fa-copy"
      />
    </div>
  </div>
</template>
<style lang="sass" scoped>
  @import src/styles/defaults/variables
  @import "src/styles/defaults/mobile-first"

  $spacing: .2em

  .input-copy-content
    display: flex
    padding: $spacing
    border: none
    text-align: left
    align-items: center
    &__value
      font-size: 1em
      flex-grow: 1
      &_box
        font-weight: 600
    &__copy-btn
      margin-left: $spacing
      font-size: .8em
      cursor: pointer
    &_box
      border: 1px solid $color-border-gray
      text-align: center
    +media-min-sm()
    +media-min-md()
    +media-min-lg()
</style>

<script>

export default {
  props: {
    value: String,
    /**
     * Modo de caixa, com borda e conteúdo centralizado.
     */
    boxMode: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    copyToClipboard() {
      this.selectText();
      document.execCommand('copy');
      this.$emit('copied');
    },
    selectText() {
      const value = this.$refs.valueContainer;
      if (window.getSelection) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(value);
        selection.removeAllRanges();
        selection.addRange(range);
      } else if (document.body.createTextRange) {
        const range = document.body.createTextRange();
        range.moveToElementText(value);
        range.select();
      }
    },
  },
};
</script>
